import {
  ApiWebhookEvent,
  IWebhookEvent,
  WebhookEventStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseMock,
  MockTimestamp,
  Properties,
  Timestamp,
} from '@principle-theorem/shared';

export class WebhookEventMock
  extends BaseMock<
    Properties<Omit<IWebhookEvent, 'cloudTaskId' | 'errorMessage'>>
  >
  implements Properties<Omit<IWebhookEvent, 'cloudTaskId' | 'errorMessage'>>
{
  eventType = ApiWebhookEvent.PatientCreated;
  data: object = {};
  timestamp: Timestamp = MockTimestamp();
  status = WebhookEventStatus.Pending;
  retryAttempts = 0;
  cloudTaskId?: string = undefined;
  errorMessage?: string = undefined;
}
